import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CoreHelperService } from 'src/app/providers/core-helper/core-helper.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderAuthGuard  {
  constructor(public _coreHelperService: CoreHelperService) { }

  canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      this._coreHelperService.isShowHeader = ( route.routeConfig && !!route.routeConfig.path && !(
      route.routeConfig.path == "login" ||
      route.routeConfig.path == "create-account" ||
      route.routeConfig.path == "forgot-password" ||
      route.routeConfig.path == "reset-password" ||
      route.routeConfig.path == "user-verification" ||
      route.routeConfig.path == "account-agreement" ||
      route.routeConfig.path == "user-agreement" ||
      route.routeConfig.path == "product-tour"
      ))
      let moduleName = !!(route.data['module']) ? route.data['module'] : "";
      this._coreHelperService.setSidebarModuleName(moduleName);
      return true;
  }
}
